import { gql } from '@apollo/client';

export const OPERATION_NAME = 'AuditLogPage';

const ROW_FIELDS = ['id', 'timestamp', 'action', 'description', 'userId', 'userName', 'userEmail'];

const PAGE_QUERY_WITH_DEBUG_DATA = buildPageDocument([...ROW_FIELDS, 'debugData']);
const PAGE_QUERY_WITHOUT_DEBUG_DATA = buildPageDocument(ROW_FIELDS);

export function auditLogPageQuery({ includeDebugData }) {
  return includeDebugData ? PAGE_QUERY_WITH_DEBUG_DATA : PAGE_QUERY_WITHOUT_DEBUG_DATA;
}

export function buildVariables({ where, limit, offset, orderBy }) {
  return { where, limit, offset, order_by: orderBy };
}

function buildPageDocument(fields) {
  return gql(`
    query ${OPERATION_NAME}(
      $where: org_audit_logs_bool_exp!
      $limit: Int!
      $offset: Int!
      $order_by: [org_audit_logs_order_by!]!
    ) {
      org_audit_logs(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
        ${fields.join('\n        ')}
      }
    }
  `);
}
